// Module
var code = `<div class="social-media-approver-container">
	<div class="card">
		<div class="card-header sticky-top">
			<div class="row">
				<!-- Titlen vises kun på skærme større end xs -->
				<div class="col-sm-4 d-none d-sm-block">
					<span class="h4 card-title">
						<i class="fas fa-chevron-right"></i> Approver <i class="fas fa-info-circle text-muted ms-1"
							style="font-size: 0.85em; cursor: help;"
							title="Rotationslogik:&#10;• Posts inden for de seneste {{\$ctrl.socialMediaConfig.postMaxAge}} timer er i rotation&#10;• Minimum {{\$ctrl.socialMediaConfig.postMinimumCount}} godkendte posts vises altid (uanset alder)&#10;• Videoer maks {{\$ctrl.socialMediaConfig.videoMaxLength}} sek"></i>
					</span>
				</div>
				<!-- Dropdown -->
				<div class="col-8 col-sm-4">
					<select ng-model="\$ctrl._selectedApprovalStatus" ng-change="\$ctrl.fetchPosts()"
						class="form-select w-100">
						<option ng-value="0">Afventer Godkendelse</option>
						<option ng-value="1">Godkendt</option>
						<option ng-value="2">Afvist</option>
					</select>
				</div>
				<!-- Tæller -->
				<div class="col-4 col-sm-4 text-end d-flex align-items-center justify-content-end flex-nowrap">
					<span class="text-nowrap"><i class="fab fa-instagram"></i>&nbsp;{{\$ctrl._posts.length}}</span>
					<span ng-if="\$ctrl._selectedApprovalStatus == 1" class="ms-2 badge bg-success text-nowrap"
						title="Posts i rotation (inden for {{\$ctrl.socialMediaConfig.postMaxAge}} timer)">
						<i class="fas fa-sync-alt"></i> {{\$ctrl.inRotationCount}} </span>
				</div>
			</div>
		</div>
	</div>
	<div class="flex-grid scrollable-column" style="padding: 0; max-height:82vh; overflow-y: auto;">
		<div ng-repeat="post in \$ctrl._posts | limitTo:\$ctrl.visibleCount" class="grid-item">
			<div class="card">
				<div class="card-body">
					<div class="post-header">
						<div>
							<strong># {{\$index + 1}}</strong>
							<span style="color:#888">/ {{\$ctrl._posts.length}}</span>
							<span style="cursor: pointer; border-bottom: 1px dotted #888;"
								title="Media Id: {{post.curatorPostId}}"></span>
							<span ng-if="post.inRotation" class="badge bg-success ms-1" title="I rotation">
								<i class="fas fa-sync-alt"></i>
							</span>
							<span ng-if="!post.inRotation" class="badge bg-secondary ms-1"
								title="Uden for rotation (ældre end {{\$ctrl.socialMediaConfig.postMaxAge}} timer)">
								<i class="fas fa-clock"></i>
							</span>
						</div>
						<div><strong>Type:</strong> {{ post.type }}</div>
						<div class="post-username" ng-if="post.username === 'roskildefestival'">
							<strong>@roskildefestival</strong></div>
						<div class="full-width"><strong>Oprettet:</strong> {{post.created | amUtc | amLocal |
							amDateFormat:'DD/MM/YYYY HH:mm'}} <span am-time-ago="post.created | amUtc | amLocal"></span>
						</div>
					</div>
					<div ng-switch on="post.type" class="media-container">
						<div ng-switch-when="video">
							<video controls="controls" disableRemotePlayback style="width: 100%;height: auto;"
								ng-src="{{post.url}}" type="video/mp4" preload="metadata" video-duration-check="post"
								video-max-length="\$ctrl.socialMediaConfig.videoMaxLength"></video>
							<div ng-if="post.videoTooLong" class="alert alert-warning mt-1 mb-0 py-1 px-2"
								style="font-size: 0.85em;">
								<i class="fas fa-exclamation-triangle"></i> Video er {{post.duration}} sek — maks
								{{\$ctrl.socialMediaConfig.videoMaxLength}} sek. Vil <strong>ikke</strong> blive
								afspillet.
							</div>
							<div ng-if="post.duration && !post.videoTooLong" class="text-muted mt-1"
								style="font-size: 0.85em;">
								<i class="fas fa-check-circle text-success"></i> {{post.duration}} sek
							</div>
						</div>
						<div ng-switch-when="image">
							<img class="img-responsive" src="{{post.url}}" alt loading="lazy">
						</div>
						<div ng-switch-default> Unsupported media type </div>
					</div>
					<div class="caption">
						<div ng-if="!post.isExpanded">{{ post.truncatedText }}</div>
						<div ng-if="post.isExpanded">{{ post.caption }}</div>
						<a ng-click="\$ctrl.toggleText(post)" ng-if="\$ctrl.shouldTruncate(post.caption)"
							style="cursor: pointer;"> {{ post.isExpanded ? 'Læs mindre' : 'Læs mere' }} </a>
					</div>
					<div class="button-container">
						<button ng-click="\$ctrl.updatePostApproval(post.id, 2)" class="btn btn-danger"
							ng-disabled="post.approvalStatus == 2">Reject</button>
						<button ng-click="\$ctrl.updatePostApproval(post.id, 1)" class="btn btn-success"
							ng-disabled="post.approvalStatus == 1">Approve</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>`;
// Exports
export default code;